import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { createOptionsList } from './helpers.js';
import { SelectQuantity } from './SelectQuantity.js';

var SelectQuantityContainer = /*#__PURE__*/ React.memo((props)=>{
    const { getLabel  } = useIntl();
    const { maxSelectableQuantity , lensesPerBox  } = props, rest = swcHelpers.objectWithoutProperties(props, [
        "maxSelectableQuantity",
        "lensesPerBox"
    ]);
    // create an array of length by maxmimumQuantity, fill it with options based on the index count
    const options = createOptionsList({
        maxSelectableQuantity,
        lensesPerBox,
        getLabel
    });
    return /*#__PURE__*/ React.createElement(SelectQuantity, swcHelpers.extends({}, rest, {
        options: options
    }));
});

export { SelectQuantityContainer };
//# sourceMappingURL=SelectQuantityContainer.js.map
